import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  Signal,
  inject
} from '@angular/core';
import { Router } from '@angular/router';
import { AdditionalInfoService } from '@services/additional-info.service';
import { UserService } from '@services/user.service';

@Component({
  selector: 'app-id-card-expired',
  templateUrl: './id-card-expired.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IdCardExpiredComponent {
  @Input() msg: string = '';
  @Input() status: string = '';
  @Output() closeModal = new EventEmitter<void>();
  private readonly infoService = inject(AdditionalInfoService);
  constructor(
    private userService: UserService,
    private router: Router
  ) {}

  ngOnInit() {
    if (this.status + '' === '401') {
      this.userService.logout().subscribe();
    }
  }

  logOut() {
    this.userService.logout().subscribe();
  }

  uploadNow() {
    this.infoService.isIdExpired = this.status + '' === '453';
    this.router.navigateByUrl('/account/edit-profile?tab=1');
  }
}
